module.exports = __webpack_public_path__ + "img/point-user.9bd86e1b.png";